import { Locale } from 'vue-i18n';
import Vehicle from '@/vehicle/models/Vehicle';
import Dossier from '@/dossier/models/Dossier';
import Customer from '@/customer/models/Customer';
import { DiagnosticTypeDescriptionId } from '@/jobs/models/diagnosis/DiagnosticTypeDescription';
import Job, { JobOrder, JobPrice } from '@/jobs/models/Job';
import { JobId } from '@/jobs/models/AbstractJob';
import Diagnostic from '@/jobs/models/diagnosis/Diagnostic';

export interface UpsellItemId {__upsellItemId: number}

export interface UpsellItem {
  id: UpsellItemId;
  description: string;
}

export interface SignableDocumentId {__signableDocumentId: number}

export enum SignableDocumentType {
  TERMS_AND_CONDITIONS = 'TC',
}

export interface SignableDocument {
  id: SignableDocumentId;
  type: SignableDocumentType;
  language: Locale;
  documentContent: string | null;
  documentURL: string | null;
}

export interface CheckInSettings {
  diagnosticTypeDescriptionId: DiagnosticTypeDescriptionId | null;
  upsellItems: Array<UpsellItem>;
  signableDocuments: Array<SignableDocument>;
  visibleJobIds: JobId[];
  keyLabelRequired: boolean;
  mileageRequired: boolean;
  locationRequired: boolean;
  hasCleaningOption: boolean;
}

export default class CheckInDetails {
  dossier!: Partial<Dossier>;
  vehicle!: Partial<Vehicle>;
  contacts!: Array<Partial<Customer>>;
  jobs!: Array<{
    id: JobId;
    details: Partial<Job>;
    price: Partial<JobPrice>;
    order: Partial<JobOrder>;
    diagnostics: Array<Diagnostic>;
  }>;

  settings!: CheckInSettings;
}